import OdfjellDatePicker from 'src/components/common/date-picker/OdfjellDatePicker';
import { InputProps } from '../OdfjellInputComponent';
import { getLuxonDateTime } from 'odfjell-date-time-utils/dateTimeUtils';
import { useMemo } from 'react';

const DateInputComponent: React.FC<Partial<InputProps>> = ({ value, elementId, onDateInputChange }: Partial<InputProps>) => {
    const datePickerValue = useMemo(() => (value ? getLuxonDateTime(value) : undefined), [value]);

    if (value) {
        return (
            <OdfjellDatePicker
                format={'dd.MM.yyyy'}
                id={elementId}
                clearIcon={false}
                value={datePickerValue}
                placeholder={''}
                onChange={(date) => onDateInputChange({ date: date.toJSDate() })}
            />
        );
    }
    return (
        <OdfjellDatePicker
            format={'dd.MM.yyyy'}
            id={elementId}
            clearIcon={false}
            placeholder={''}
            onChange={(date) => onDateInputChange({ date: date.toJSDate() })}
        />
    );
};

export default DateInputComponent;
